import { render, staticRenderFns } from "./AnimatedTextIteration.vue?vue&type=template&id=3a530f18&scoped=true&"
import script from "./AnimatedTextIteration.vue?vue&type=script&lang=ts&"
export * from "./AnimatedTextIteration.vue?vue&type=script&lang=ts&"
import style0 from "./AnimatedTextIteration.vue?vue&type=style&index=0&id=3a530f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a530f18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
